_context.invoke(function(Nittro) {
    var builder = new Nittro.DI.ContainerBuilder({
        "params": {},
        "extensions": {
            "ajax": "Nittro.Ajax.Bridges.AjaxDI.AjaxExtension()",
            "page": "Nittro.Page.Bridges.PageDI.PageExtension()",
            "forms": "Nittro.Forms.Bridges.FormsDI.FormsExtension()",
            "flashes": "Nittro.Flashes.Bridges.FlashesDI.FlashesExtension()"
        },
        "services": {},
        "factories": {}
    });

    this.di = builder.createContainer();
    this.di.runServices();

});